import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { UpstreamTransportationAndDistribution } from "../../../../api";

export const upstreamTransportationAndDistributionKeys = {
  items: () => ["upstreamTransportationAndDistributionItems"]
};

export function useGetUpstreamTransportationAndDistributionItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [
      ...upstreamTransportationAndDistributionKeys.items(),
      params.queryParams.page, params.queryParams.size, params.queryParams.sort
    ], () => callApi(UpstreamTransportationAndDistribution.getUpstreamTransportationAndDistributionItems, params),
    config);
}

export function useAddUpstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(UpstreamTransportationAndDistribution.addUpstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useUpdateUpstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(UpstreamTransportationAndDistribution.updateUpstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId,
      data
    }), config);
}

export function useDeleteUpstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(UpstreamTransportationAndDistribution.deleteUpstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId
    }), config);
}

export function useImportUpstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(UpstreamTransportationAndDistribution.importUpstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useDownloadUpstreamTransportationAndDistributionTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(UpstreamTransportationAndDistribution.getUpstreamTransportationAndDistributionTemplate), config);
}